const locales = {
  forgotYourPassword: 'Forgot your password?',
  itHappens: 'It happens.',
  enterYourEmail: "Enter your email and we'll send you instructions on how to reset your password.",
  emailAddress: 'Email address',
  sendInstructions: 'Send Instructions',
  goBackTo: 'Go back to',
  loginPage: 'Login page',
  emailNotRecognized: 'Email not recognized',
  instructionsEmailWasSent: 'Instructions email was sent',
  emailIsRequired: 'Email address is required',
  emailShouldBeWinfico: 'Should be @winfico.com Email',
  hangTightLoading: 'Hang tight ! We are sending you an Email!',
};

export default locales;
